import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { X } from 'lucide-react';
import { getAvailableWidgets } from '@/lib/widgetsConfig';
import { useAuth } from '@/context/AuthContext';

Modal.setAppElement('#root');

export default function WidgetLibrary({ isOpen, onClose, onSelectWidget }) {
  const { hasRole } = useAuth();
  const isSuperAdmin = hasRole('SUPER_ADMIN');
  const availableWidgets = getAvailableWidgets(isSuperAdmin);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Todos' },
    { id: 'metric_card', name: 'Métricas' },
    { id: 'bar_chart', name: 'Gráficos de Barras' },
    { id: 'pie_chart', name: 'Gráficos de Pizza' },
  ];

  const filteredWidgets = selectedCategory === 'all' 
    ? availableWidgets 
    : availableWidgets.filter(w => w.type === selectedCategory);

  const handleSelectWidget = (widget) => {
    onSelectWidget(widget);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="modal-content max-w-4xl mx-auto mt-20 bg-white rounded-lg shadow-xl p-6"
      overlayClassName="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center overflow-y-auto"
    >
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-semibold text-slate-900">Biblioteca de Widgets</h2>
        <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
          <X className="w-6 h-6" />
        </button>
      </div>

      <div className="flex gap-2 mb-6 overflow-x-auto pb-2">
        {categories.map(cat => (
          <button
            key={cat.id}
            onClick={() => setSelectedCategory(cat.id)}
            className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
              selectedCategory === cat.id
                ? 'bg-blue-600 text-white'
                : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-h-96 overflow-y-auto">
        {filteredWidgets.map(widget => (
          <Card
            key={widget.id}
            className="p-4 cursor-pointer hover:shadow-lg transition-shadow border-2 border-transparent hover:border-blue-500"
            onClick={() => handleSelectWidget(widget)}
          >
            <div className="flex items-start gap-3">
              <div className="text-3xl">{widget.icon}</div>
              <div className="flex-1">
                <h3 className="font-semibold text-slate-900">{widget.title}</h3>
                <p className="text-xs text-slate-500 mt-1">
                  {widget.type === 'metric_card' && 'Card de Métrica'}
                  {widget.type === 'bar_chart' && 'Gráfico de Barras'}
                  {widget.type === 'pie_chart' && 'Gráfico de Pizza'}
                </p>
              </div>
            </div>
          </Card>
        ))}
      </div>

      {filteredWidgets.length === 0 && (
        <div className="text-center py-12 text-slate-400">
          Nenhum widget disponível nesta categoria
        </div>
      )}
    </Modal>
  );
}
